import { api } from '@/api/client';

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

/**
 * Синхронизировать PushSubscription с сервером (после granted Notification + готового SW).
 */
export async function syncWebPushSubscriptionWithServer(): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;

  let publicKey: string;
  try {
    const res = await api.push.getVapidPublicKey();
    publicKey = res.publicKey;
  } catch {
    return;
  }

  if (!publicKey) return;

  const registration = await navigator.serviceWorker.ready;
  if (!registration.pushManager) return;

  const existing = await registration.pushManager.getSubscription();
  const sub =
    existing ??
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey) as unknown as BufferSource,
    }));

  const json = sub.toJSON();
  if (!json.endpoint || !json.keys?.p256dh || !json.keys?.auth) return;

  try {
    await api.push.subscribe(json, { channel: 'web_push' });
  } catch {
    /* сеть / 401 */
  }
}

/** Unsubscribe current browser push from server + browser (logout). */
export async function unsubscribeWebPushFromServer(): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  try {
    const registration = await navigator.serviceWorker.ready;
    const sub = await registration.pushManager?.getSubscription();
    if (!sub) return;
    const endpoint = sub.endpoint;
    try {
      await api.push.unsubscribe(endpoint);
    } catch {
      /* ignore */
    }
    try {
      await sub.unsubscribe();
    } catch {
      /* ignore */
    }
  } catch {
    /* ignore */
  }
}
